import type { ContentRef } from '@gitbook/api-client';
import { assertNever } from '@gitbook/util-ts';

function hashValue(value: string | undefined): string {
    if (value === undefined) {
        return 'u';
    }

    return `s:${value}`;
}

/**
 * Hash a reference into a stable string representation.
 */
export function hashContentRef(ref: ContentRef): string {
    switch (ref.kind) {
        case 'space':
            return `space|${hashValue(ref.space)}`;
        case 'page':
            return `page|${hashValue(ref.page)}|${hashValue(ref.space)}`;
        case 'anchor':
            return `anchor|${hashValue(ref.anchor)}|${hashValue(ref.page)}|${hashValue(ref.space)}`;
        case 'file':
            return `file|${hashValue(ref.file)}|${hashValue(ref.space)}`;
        case 'url':
            return `url|${hashValue(ref.url)}`;
        case 'user':
            return `user|${hashValue(ref.user)}`;
        case 'reusable-content':
            return `reusable-content|${hashValue(ref.reusableContent)}|${hashValue(ref.space)}`;
        case 'tag':
            return `tag|${hashValue(ref.tag)}|${hashValue(ref.space)}`;
        case 'openapi':
            return `openapi|${hashValue(ref.spec)}`;
        case 'collection':
            return `collection|${hashValue(ref.collection)}`;
        default:
            assertNever(ref);
    }
}

/**
 * Compare two references.
 * It returns true if both are equal.
 */
export function contentReferencesAreEqual(
    r1: ContentRef | null | undefined,
    r2: ContentRef | null | undefined
): boolean {
    if (r1 === null && r2 === null) {
        return true;
    }

    if (typeof r1 === 'undefined' && typeof r2 === 'undefined') {
        return true;
    }

    if (!r1 || !r2) {
        return false;
    }

    return hashContentRef(r1) === hashContentRef(r2);
}
